import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const FIELD_ASSIST_PATH = '/subcontractor/dashboard/field-assist';

// Always-on-hand launcher for Field Assist. The desktop sidebar has no Field Assist entry and the mobile bottom
// nav (which does) is hidden on md+, so on tablet/desktop this floating pill is the way in. It's hidden on mobile
// (the bottom nav already carries "Assist" there) and on the Field Assist page itself (where it'd be redundant and
// cover content).
const FieldAssistFab = () => {
  const location = useLocation();
  if (location.pathname.startsWith(FIELD_ASSIST_PATH)) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 12, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ type: 'spring', stiffness: 320, damping: 26, delay: 0.15 }}
      className="fixed bottom-6 right-6 z-40 hidden md:block"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <NavLink
        to={FIELD_ASSIST_PATH}
        aria-label="Open Field Assist"
        className={cn(
          'group relative flex min-h-11 items-center gap-2.5 rounded-full bg-primary px-5 py-3',
          'font-semibold text-white shadow-glow transition-all duration-200',
          'hover:scale-[1.03] hover:shadow-[0_12px_40px_rgba(37,99,235,0.5)]',
          'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2',
          'focus-visible:ring-offset-background active:scale-95'
        )}
      >
        {/* soft pulsing halo to draw the eye toward the assistant */}
        <span className="pointer-events-none absolute inset-0 rounded-full bg-primary/40 opacity-70 blur-md transition-opacity duration-300 group-hover:opacity-100" aria-hidden="true" />
        <img src="/field-assist-logo.png" alt="" className="relative h-6 w-6 shrink-0" />
        <span className="relative text-sm">Field Assist</span>
      </NavLink>
    </motion.div>
  );
};

export default FieldAssistFab;
